import * as React from 'react';

const Wifi = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 147.402 147.402"
        xmlSpace="preserve"
    >
        <path d="M9 113.199c-4.971 0-9 4.029-9 9s4.029 9 9 9a7.21 7.21 0 0 1 7.203 7.203c0 4.971 4.029 9 9 9s9-4.029 9-9c0-13.897-11.306-25.203-25.203-25.203zM9 56.158c-4.971 0-9 4.029-9 9s4.029 9 9 9c35.425 0 64.244 28.819 64.244 64.244 0 4.971 4.029 9 9 9s9-4.029 9-9C91.244 93.053 54.35 56.158 9 56.158z" />
        <path d="M9 0a9 9 0 0 0 0 18c66.39 0 120.402 54.012 120.402 120.401 0 4.971 4.029 9 9 9s9-4.029 9-9C147.402 62.087 85.315 0 9 0z" />
    </svg>
);

export default Wifi;
